import { LazyLoad } from 'features/common/ui/LazyLoad'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'
import RequireFeatureFlag from 'app/ui/RequireFeatureFlag'
import { FeatureFlag } from 'app/types'
import { lazy } from 'app/lazy'

const ProjectsPage = lazy(() => import('./ProjectsPage'))

const routes = {
  path: 'projects',
  element: (
    <LazyLoad>
      <AuthenticatedRoute
        element={
          <RequireFeatureFlag flag={FeatureFlag.ProjectsForTheWorkspace}>
            <ProjectsPage />
          </RequireFeatureFlag>
        }
      />
    </LazyLoad>
  )
}

export default routes
